"use client";

import { IconCrossSmallGold } from "@repo/assets/images";
import { useFilterOptions } from "@repo/lib/hooks/catalog";
import { Button } from "@repo/ui";
import { useTranslations } from "next-intl";
const AppliedFilters = ({
  appliedFilters,
  appliedFilterCount
}) => {
  const t = useTranslations("Common");
  const {
    selectedValues,
    handleCheckboxChange,
    clearAllFilters
  } = useFilterOptions();
  return <div className="flex flex-nowrap gap-2.5" data-sentry-component="AppliedFilters" data-sentry-source-file="AppliedFilters.jsx">
      <div className="text-toolbar-heading h-[36px] min-w-[65px] text-sm font-semibold leading-[36px] md:h-[44px] md:min-w-max md:leading-[44px]">
        {appliedFilterCount}{" "}
        {appliedFilterCount > 1 ? t("Filters") : t("Filter")}:
      </div>
      <div className="flex gap-2.5 overflow-auto [&::-webkit-scrollbar]:hidden">
        {Object.entries(appliedFilters || [])?.map(([filterKey, filterValues]) => {
        const type = filterKey;
        return filterValues?.map(item => {
          return <div key={item?.value} id={filterKey}>
                  <label htmlFor={`${item.value}`}>
                    <span className="border-toolbar-border text-toolbar-filter-text flex h-[36px] cursor-pointer items-center space-x-2.5 whitespace-nowrap border px-3 leading-none md:h-[44px] rtl:space-x-reverse">
                      <span className="text-left text-sm">
                        <span className="block">{item?.name}</span>
                      </span>
                      <input type="checkbox" value={item.value} id={item.value} onChange={event => {
                  handleCheckboxChange(event, type);
                }} className="accent-toolbar-filter-active text-toolbar-filter-checkboxTick me-3 hidden size-[18px]" checked={selectedValues[type]?.includes(item.value) || false} />
                      <IconCrossSmallGold className="text-toolbar-activeIcon fill-current" />
                    </span>
                  </label>
                </div>;
        });
      })}
      </div>
      <div className="min-w-max self-center md:block">
        <Button onClick={clearAllFilters} type="button" variant="secondary" size="md" data-sentry-element="Button" data-sentry-source-file="AppliedFilters.jsx">
          {t("Clear_All")}
        </Button>
      </div>
    </div>;
};
export default AppliedFilters;